import Vue from "vue";
import Vuex from "vuex";
import { obtenerPopUps } from "@/services/contenido";
import auth from "@/services/auth";
import generales from "@/services/generales";
import _ from "lodash";
import indicadores from "@/services/indicadores";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    contadorTickets: {
      ticket_soporte: null,
      ticket_actualizacion: null,
      ticket_cotizacion: null,
      ticket_desarrollo: null,
      ticket_capacitacion: null,
    },
    informativoPerfil: "",
    informativoSideBar: "",
    comunicados: [],
    bitsCliente: {
      b_soporte: false,
      b_desarrollo: false,
      b_actualizacion: false,
      b_cotizacion: false,
      b_capacitacion: false,
      //Bits de sucursales
      sucur_b_produccion: false,
      sucur_b_certificacion: false,
      b_modulo: false,
      b_desarrollo: false,
    },
    parametros: [],
    paramGenerales: {},
    dialogoAniversario: false,
    snackbar: {
      mostrar: false,
      mensaje: "",
      color: "",
      icon: "",
    },
    drawer: true,
    rutaActual: "",
    loadingContador: true,
    loadingState: false,
    loadingPopUps: false,
    loadingParametros: true,
    popUps: [],
    tooltip: false,
    mini: false,
    indicadores: {
      dolar: 1,
      uf: 1,
    },
    expireTimeout: null,
    blockAccess: false,
  },
  getters: {
    getDrawer: (state) => {
      return state.drawer;
    },
    getTooltip: (state) => {
      return state.tooltip;
    },
    getMini: (state) => {
      return state.mini;
    },
    getParams: (state) => {
      return state.parametros.reduce((obj, item) => {
        obj[item.id] = {
          nombre: item.nombre,
          texto: item.texto,
          valor: item.valor,
        };
        return obj;
      }, {});
    },
  },
  mutations: {
    SET_SNACKBAR(state, payload) {
      state.snackbar = payload;
    },
    CLOSE_SNACKBAR(state) {
      state.snackbar.mostrar = false;
    },
    SET_DRAWER(state, value) {
      state.drawer = value;
    },
    SET_DIALOGO(state, value) {
      state.dialogoAniversario = value;
    },
    SET_CONTADORES(state, value) {
      state.contadorTickets = value;
    },
    cambiarRuta(state, ruta) {
      state.rutaActual = ruta;
    },
    SET_BITS(state, value) {
      state.bitsCliente = value;
    },
    SET_INFORMATIVOS(state, value) {
      if (value.length > 0) {
        state.informativoPerfil = value.find(
          (item) => item.id == 3121
        )?.mensaje;
        state.informativoSideBar = value.find(
          (item) => item.id == 3122
        )?.mensaje;
      }
    },
    SET_COMUNICADOS(state, value) {
      state.comunicados = value;
    },
    SET_PARAMETROS(state, value) {
      state.parametros = value;
    },

    SET_PARAMETROS_GENERALES(state, value) {
      state.paramGenerales = value;
    },
    SET_POPUPS(state, value) {
      state.popUps = value;
    },
    SET_LOADING_POPUPS(state, value) {
      state.loadingPopUps = value;
    },
    SET_LOADING_CONTADOR(state, value) {
      state.loadingContador = value;
    },
    SET_LOADING_STATE(state, value) {
      state.loadingState = value;
    },
    SET_LOADING_PARAMETROS_GENERALES(state, value) {
      state.loadingParametros = value;
    },
    SET_TOOLTIP(state, value) {
      state.tooltip = value;
    },
    SET_MINI(state, value) {
      state.mini = value;
    },
    SET_INDICADORES(state, value) {
      state.indicadores = value;
    },
    SET_TIMEOUT(state, remaining) {
      state.expireTimeout = setTimeout(function () {
        alert(
          "Su sesión ha expirado, si quiere seguir utilizando el portal ingrese nuevamente"
        );
        auth.cerrarSesion();
      }, remaining);
    },
    CLOSE_TIMEOUT(state) {
      clearTimeout(state.expireTimeout);
    },
    SET_BLOCK_ACCESS(state, value) {
      state.blockAccess = value;
    },
  },
  actions: {
    setTimeout({ commit }) {
      let current = new Date().getTime();
      let expires = new Date(sessionStorage.getItem("userLoggedTicketExpired"));
      let remaining = expires.getTime() - current;
      if (process.env.VUE_APP_MODE !== "PROD")
        console.log(
          "Expiración: ",
          expires.getHours() +
            ":" +
            (expires.getMinutes() < 10
              ? "0" + expires.getMinutes()
              : expires.getMinutes())
        );
      commit("SET_TIMEOUT", remaining);
    },
    closeTimeout({ commit }) {
      commit("CLOSE_TIMEOUT");
    },
    mostrarDialogo({ commit }, value) {
      commit("SET_DIALOGO", value);
    },
    mostrarTooltip({ commit }, value) {
      commit("SET_TOOLTIP", value);
    },
    mostrarAlerta({ commit }, payload) {
      if (payload.color === "success") {
        payload.icon = "mdi-check-circle-outline";
      } else if (payload.color === "warning") {
        payload.icon = "mdi-alert-outline";
      } else if (payload.color === "error") {
        payload.icon = "mdi-alert-octagon-outline";
      } else if (payload.color === "info") {
        payload.icon = "alert-circle-outline";
      }

      commit("SET_SNACKBAR", {
        mostrar: true,
        color: payload.color,
        mensaje: payload.mensaje,
        icon: payload.icon,
      });
    },
    cerrarAlerta({ commit }) {
      commit("CLOSE_SNACKBAR");
    },

    switchDrawer({ commit }, value) {
      commit("SET_DRAWER", value);
    },
    async updateBits({ commit }) {
      if (process.env.VUE_APP_MODE !== "PROD") {
        console.log("Actualizando bits");
      }
      commit("SET_LOADING_STATE", true);
      let data = auth.getUserLogged().usuario;
      await auth
        .bitsUsuario(data)
        .then((response) => {
          let bits = _.cloneDeep(response.data);
          commit("SET_BITS", bits);
        })
        .catch((error) => console.error(error));
      commit("SET_LOADING_STATE", false);
    },
    async updateInformativos({ commit }, accion) {
      let id_sucursal = auth.getUserLogged().id_sucursal;
      await generales
        .obtenerInformativos(id_sucursal, accion)
        .then((response) => {
          let informativos = response.data;
          if (accion == 1) commit("SET_INFORMATIVOS", informativos);
          else commit("SET_COMUNICADOS", informativos);
        })
        .catch((error) => console.error(error));
    },
    async updateParametros({ commit }) {
      let data = auth.getUserLogged().id_sucursal;
      await generales
        .obtenerParametros(data)
        .then((response) => {
          commit("SET_PARAMETROS", response.data);
        })
        .catch((error) => console.error(error));
    },
    async actualizarContador({ commit }) {
      commit("SET_LOADING_CONTADOR", true);
      let data = auth.getUserLogged().id_usuario;
      await auth
        .obtener_contadores(data)
        .then((response) => {
          let data = response.data;
          commit("SET_CONTADORES", data);
        })
        .catch((error) => console.error(error));
      commit("SET_LOADING_CONTADOR", false);
    },
    async obtenerIndicadores({ commit, dispatch }) {
      await indicadores
        .valoresBD()
        .then(async (res) => {
          let data = res.data;
          if (data && data.dolar > 1 && data.uf > 1) {
            commit("SET_INDICADORES", {
              dolar: data.dolar,
              uf: data.uf,
            });
          } else {
            await dispatch("obtenerIndicadoresWEB");
          }
        })
        .catch(async (error) => {
          console.error(error);
          await dispatch("obtenerIndicadoresWEB");
        });
    },
    async obtenerIndicadoresWEB({ commit }) {
      await indicadores
        .valores()
        .then((res) => {
          let data = res.data;
          if (data) {
            commit("SET_INDICADORES", {
              dolar: data.dolar.valor,
              uf: data.uf.valor,
            });
          }
        })
        .catch((error) => console.error(error));
    },
    async initData({ dispatch, commit }) {
      let promises = [dispatch("obtenerParametrosGenerales")];
      if (auth.isAuthenticated()) {
        promises = promises.concat([
          dispatch("setTimeout"),
          dispatch("updateBits"),
          dispatch("updateParametros"),
          dispatch("actualizarContador"),
          dispatch("updateInformativos", 1),
          dispatch("updateInformativos", 2),
        ]);
        if (auth.getUserLogged().b_maes && process.env.VUE_APP_MODE === "PROD")
          commit("SET_BLOCK_ACCESS", true);
      }
      await Promise.all(promises);
    },
    limpiarSesionData({ commit }) {
      commit("CLOSE_TIMEOUT");
      commit("SET_BITS", {
        b_soporte: false,
        b_desarrollo: false,
        b_actualizacion: false,
        b_cotizacion: false,
        b_capacitacion: false,
        sucur_b_modulo: false,
        sucur_b_produccion: false,
        sucur_b_certificacion: false,
      });
      commit("SET_BLOCK_ACCESS", false);
      commit("SET_INFORMATIVOS", []);
      commit("SET_COMUNICADOS", []);
      commit("SET_PARAMETROS", []);
      commit("SET_PARAMETROS_GENERALES", {});
    },
    async obtenerPopUps({ commit }) {
      commit("SET_LOADING_POPUPS", true);
      await obtenerPopUps()
        .then((res) => {
          if (res.data.length > 0) {
            commit("SET_POPUPS", res.data);
            commit("SET_DIALOGO", true);
          }
        })
        .catch((error) => console.error(error));
      commit("SET_LOADING_POPUPS", false);
    },
    async obtenerParametrosGenerales({ commit }) {
      commit("SET_LOADING_STATE", true);
      await generales
        .obtenerParametrosGenerales()
        .then((res) => {
          commit("SET_PARAMETROS_GENERALES", res.data);
        })
        .catch((error) => console.error(error));
      commit("SET_LOADING_STATE", false);
    },
  },
});
